import React from 'react';
import { Box, CardContent, Typography, Chip } from '@mui/material';
import { SportsSoccer as BallIcon } from '@mui/icons-material';
import { C } from './constants';
import { GlowCard, MemberRow } from './ui';

/**
 * SquadCard — scrollable list of players.
 *
 * Props:
 *   players — enriched player objects (with teamMemberInfo attached)
 */
const SquadCard = ({ players = [], delay = 0 }) => (
  <GlowCard delay={delay} accent={C.accent}>
    <CardContent sx={{ p: 3 }}>

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <BallIcon sx={{ color: C.accent, fontSize: 20 }} />
          <Typography sx={{ fontFamily: 'Syne', fontWeight: 700, color: C.text, fontSize: '1rem' }}>
            Effectif
          </Typography>
        </Box>
        <Chip
          label={`${players.length} joueur${players.length !== 1 ? 's' : ''}`}
          size="small"
          sx={{
            background: `${C.accent}18`, border: `1px solid ${C.accent}30`,
            color: C.accent, fontFamily: 'DM Sans', fontSize: '0.72rem',
          }}
        />
      </Box>

      <Box sx={{
        maxHeight: 320, overflowY: 'auto', pr: 0.5,
        '&::-webkit-scrollbar': { width: 4 },
        '&::-webkit-scrollbar-track': { background: 'transparent' },
        '&::-webkit-scrollbar-thumb': { background: C.border, borderRadius: 99 },
      }}>
        {players.length === 0
          ? <Typography sx={{ fontFamily: 'DM Sans', color: C.muted, fontSize: '0.85rem' }}>Aucun joueur trouvé.</Typography>
          : players.map((m, i) => <MemberRow key={m._id} member={m} index={i} />)
        }
      </Box>

    </CardContent>
  </GlowCard>
);

export default SquadCard;
